<template>
  <div class="input-box-bg">
    <template v-if="!show_input_box">
      <div class="input-box-wrap">
        <div class="jgz_plbg">
          <img src="@/assets/images/comment/jgz_plbg.png" alt />
        </div>
        <input class="input-box" @click="showInputBox()" type="text" :placeholder="placeholder" />
      </div>
    </template>
    <template v-else>
      <span class="title">{{ $t('comment.comment') }}</span>
      <div class="inpout-box-content-wrap">
        <textarea
          ref="input_box_textarea"
          class="content-input"
          @input="contentInput"
          v-model="text_content"
          :placeholder="placeholder"
          v-bind:maxlength="300"
          @click="inputFoucs"
          @blur="scrollToTop"
        ></textarea>
        <uploader ref="input_box_uploader"></uploader>
      </div>
      <div class="send-wrap">
        <span class="count">{{ text_content.length }}/300</span>
        <img
          @click="showEmojiPanel"
          class="emoji-click"
          src="@/assets/images/comment/emoji.png"
          alt
        />
        <div style="flex: 1"></div>
        <div @click.stop="cancel" class="exit-send">{{ $t('comment.cancel') }}</div>
        <div
          @click.stop="sendMessage"
          :class="['text-send', is_sending ? 'text-send-hui' : 'text-send-lan']"
        >{{ is_sending ? $t('comment.sending') : $t('comment.send') }}</div>
      </div>
      <div v-if="show_emoji_panel" class="emoji-con" :style="{ width: pc_width_580 }">
        <face-panel @onFaceChoose="handleFaceChoose"></face-panel>
      </div>
    </template>
  </div>
</template>

<script>
import pc from '@/js/pc.js'
import FacePanel from '@/js/comment/facePanel/FacePanel'
import Uploader from '../Common/Uploader.vue'

export default {
    components: {
        FacePanel,
        Uploader
    },
    props: {
        content: {
            type: Object,
            require: true,
            defalut: {}
        }
    },
    computed: {
        pc_width_580() {
            return pc.isPC() ? '580px' : '100%'
        }
    },
    data() {
        return {
            text_content: '',
            placeholder: this.$t('comment.comment_placehold'),
            defaultList: [],
            uploadList: [],
            fileList: [],
            show_emoji_panel: false,
            show_input_box: false,
            is_sending: false
        }
    },
    created() {},
    methods: {
        contentInput() {
            if (this.text_content.length > 300) {
                this.text_content = this.text_content.substring(0, 300)
            }
        },
        inputFoucs() {
            this.show_emoji_panel = false
        },
        scrollToTop() {
            // 修复微信的BUG
            setTimeout(() => {
                window.scroll(0, 0)
            }, 30)
        },
        handleSuccess(e) {
            console.log(e)
        },
        handleFormatError() {},
        handleMaxSize() {},
        handleBeforeUpload() {},
        cancel() {
            this.reset()
            this.scrollToTop()
        },
        handleFaceChoose(face) {
            const value = this.text_content
            const el = this.$refs.input_box_textarea
            const startPos = el.selectionStart
            const endPos = el.selectionEnd
            const newValue =
                value.substring(0, startPos) + face + value.substring(endPos, value.length)
            this.text_content = newValue
            if (el.setSelectionRange) {
                setTimeout(() => {
                    const index = startPos + face.length
                    el.setSelectionRange(index, index)
                }, 0)
            }
        },
        sendMessage() {
            if (this.is_sending) return
            const message = {
                text: this.text_content,
                images: this.$refs.input_box_uploader.getFileList()
            }
            this.$emit(
                'send-message',
                function(task) {
                    this.is_sending = true
                    task(message)
                        .then(data => {
                            this.reset()
                        })
                        .catch(error => {
                            this.is_sending = false
                            alert('消息发送失败请稍后再试')
                        })
                }.bind(this)
            )
        },
        showEmojiPanel() {
            this.show_emoji_panel = !this.show_emoji_panel
        },
        showInputBox(placeholder) {
            if (placeholder) this.placeholder = placeholder
            this.show_input_box = true
            this.$emit('show-input-box', true)
            this.$nextTick(() => {
                this.$refs.input_box_textarea.focus()
            })
        },
        reset() {
            this.is_sending = false
            this.show_input_box = false
            this.show_emoji_panel = false
            this.text_content = ''
            this.placeholder = this.$t('comment.comment_placehold')
            this.$emit('show-input-box', false)
        }
    }
}
</script>

<style scoped>
.input-box-bg {
    width: 100%;
    border-top: 1px solid #dddddd;
    background: #fff;
    z-index: 1;
}

.input-box-bg .title {
    display: inline-block;
    font-size: 16px;
    font-weight: 695;
    margin-top: 0.3rem;
    margin-left: 0.5rem;
}

.inpout-box-content-wrap {
    width: 100%;
    position: relative;
    padding: 0 0.5rem;
}

.input-box-wrap .input-box {
    font-size: 16px;
}

.content-input {
    width: 100%;
    height: 1.5rem;
    border: none;
    font-size: 16px;
    resize: none;
    padding: 0 0.2rem;
    margin: 0.2rem 0;
}

.demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.demo-upload-list img {
    width: 100%;
    height: 100%;
}

.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}

.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}

.send-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0.1rem 0.5rem 0.5rem 0.2rem;
}

.send-wrap .count {
    font-size: 16px;
    margin-left: 0.5rem;
    font-weight: 300;
}

.emoji-click {
    width: 0.77rem;
    height: 0.77rem;
    margin-left: 0.32rem;
    display: inline-block;
    margin-top: -0.1rem;
    cursor: pointer;
}

.text-send {
    margin-right: 1rem;
    width: 3rem;
    height: 1.5rem;
    color: #fff;
    border: none;
    background-size: 100% 100%;
}

.text-send-lan {
    background: url('../../assets/images/comment/pl_send.png') no-repeat center;
}

.text-send-hui {
    background: url('../../assets/images/comment/pl_send_hui.jpg') no-repeat center;
}

.text-send,
.exit-send {
    width: 2.56rem;
    height: 1.28rem;
    line-height: 1.28rem;
    border: none;
    background-size: 100% 100%;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
}

.text-send {
    color: white;
}

.exit-send {
    margin-right: 0.5rem;
    border: none;
    background: url('../../assets/images/comment/pl_exit.png') no-repeat center;
    background-size: 100% 100%;
}

.emoji-con {
    background-color: #f6f6f6;
    width: 100%;
    overflow: hidden;
    padding-bottom: 1rem;
}

.input-box-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 2.14rem;
    background: white;
    border: none;
    /* border-top: 1px solid #dddddd; */
}

.input-box {
    width: 89.3%;
    height: 1.7rem;
    text-indent: 0.5rem;
    border: none;
    background: #f4f4f4;
    border-radius: 5px;
}

.jgz_plbg {
    width: 100%;
    height: 0.5rem;
    position: absolute;
    top: -0.5rem;
}

.jgz_plbg img {
    display: block;
    width: 100%;
    height: 100%;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .input-box-bg {
        padding-left: 0.2rem;
        box-sizing: border-box;
    }

    .content-input {
        box-sizing: border-box;
        overflow: auto;
        width: 95%;
    }
}
</style>